export function sortByWeight(a, b) {
  return b.room_classification.weight - a.room_classification.weight
}
